import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Get_Permissions_Type } from '../../store/Lookup/lookupSlice';
const useGetPermissionsType = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (Permissions_Type.length === 0) {
      // @ts-ignore
      dispatch(Get_Permissions_Type());
    }
  }, []);

  const { Permissions_Type, loading, error } = useSelector((state) => state.Lookup);

  return { Permissions_Type, loading, error };
};

export default useGetPermissionsType;
